import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class VerifyAuthenticationService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {getCurrentUserService} deps.service
   * @param {verifyAuthenticationValueObjectFactory} deps.vo
   * @param {httpAuthenticationRepository} deps.repository
   * @param {cookieAuthenticationRepository} deps.repository
   * @param {Object} deps.log
   */
  constructor({
    config,
    getCurrentUserService,
    verifyAuthenticationValueObjectFactory,
    httpAuthenticationRepository,
    cookieAuthenticationRepository,
    log
  }) {
    super({
      config,
      getCurrentUserService,
      verifyAuthenticationValueObjectFactory,
      httpAuthenticationRepository,
      cookieAuthenticationRepository,
      log
    })
    this._config = config
    this._getCurrentUserService = getCurrentUserService
    this._verifyAuthenticationValueObjectFactory = verifyAuthenticationValueObjectFactory
    this._httpAuthenticationRepository = httpAuthenticationRepository
    this._cookieAuthenticationRepository = cookieAuthenticationRepository
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>}
   */
  execute = async () => {
    const userEntity = await this._getCurrentUserService.execute()

    if (!userEntity) {
      return this._verifyAuthenticationValueObjectFactory({
        logged: false
      }).toJSON()
    }

    const [authenticationTokenError, authenticationToken] =
      await this._httpAuthenticationRepository.getAuthenticationToken({
        userEntity
      })

    authenticationTokenError && this._cookieAuthenticationRepository.clearUserData()

    const logged = Boolean(authenticationToken)

    return this._verifyAuthenticationValueObjectFactory({
      logged
    }).toJSON()
  }
}
